import React, { useState } from "react";
import axios from "axios";
import { Typography, Space, Input, Button, Form, Card, message } from "antd";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { firebaseAPI } from "../firebaseConfig";
import axiosInstance from "../utils/axiosInstance";

const { Title } = Typography;

const AddJudgePage = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const location = useLocation(); // Hook to get current location
  const [programName, setProgramName] = useState(
    decodeURI(location.pathname.split("/")[1])
  );

  const handleSubmit = async (values) => {
    let token = Cookies.get("token") || "";

    try {
      const response = await axiosInstance.post(
        `${firebaseAPI}/users`,
        {
          name: values.name,
          email: values.email,
          programName: programName,
          role: "judge",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Show success message
      message.success("Judge Added successfully");

      // Clear the form fields after successful submission
      setName("");
      setEmail("");
    } catch (error) {
      // Show error message if request fails
      message.error(error.response.data.message || "Failed to add judge");
      console.error("Error adding judge:", error);
    }
  };

  return (
    <div
      style={{ marginTop: "50px", display: "flex", justifyContent: "center" }}
    >
      <Card
        style={{
          width: "500px",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={2} style={{ textAlign: "center" }}>
          Add Judge
        </Title>
        <Form layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: "Please enter name" }]}
          >
            <Input
              type="text"
              placeholder="Enter name"
              value={name}
              onChange={(event) => setName(event.target.value)}
            />
          </Form.Item>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: "Please enter email" }]}
          >
            <Input
              placeholder="Enter email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              type="email"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%", borderRadius: "5px" }}
            >
              Add Judge
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default AddJudgePage;
